module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Add New Client")])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client Type"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.form.client_type && _vm.errorList.client_type ? 'red' : '',
    }),
    attrs: {
      "list": _vm.clientTypes,
      "option-value": "clientTypeVal",
      "option-text": "clientTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.form.client_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "client_type", $$v)
      },
      expression: "form.client_type"
    }
  }), _vm._v(" "), (!_vm.form.client_type && _vm.errorList.client_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.client_type) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client Name"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.client_name && _vm.errorList.client_name ? 'red' : '',
    }),
    attrs: {
      "id": "client-name",
      "required": ""
    },
    model: {
      value: (_vm.form.client_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "client_name", $$v)
      },
      expression: "form.client_name"
    }
  }), _vm._v(" "), (!_vm.form.client_name && _vm.errorList.client_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.client_name) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Email"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.email && _vm.errorList.email) || _vm.errorEmailFormat ? 'red' : '',
    }),
    attrs: {
      "id": "client-email",
      "type": "email",
      "required": ""
    },
    on: {
      "keyup": _vm.isEmailValid
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), (!_vm.form.email && _vm.errorList.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.email) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.form.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.emailError))]) : _vm._e(), _vm._v(" "), (_vm.form.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmailFormat))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Mobile Number"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.mobile && _vm.errorList.mobile) || _vm.errorMobileFormat ? 'red' : '',
    }),
    attrs: {
      "id": "client-mobile",
      "type": "text",
      "required": ""
    },
    on: {
      "input": _vm.isMobileValid
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  }), _vm._v(" "), (!_vm.form.mobile && _vm.errorList.mobile) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.mobile) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.form.mobile && _vm.errorMobileFormat) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(">" + _vm._s(_vm.errorMobileFormat))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("TAN No (AAAA12345A)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_not_tan),
      expression: "form.is_not_tan"
    }],
    staticClass: "mt-5",
    attrs: {
      "id": 'is_not_tan',
      "name": "checkbox-tan",
      "type": "checkbox",
      "value": "1",
      "unchecked-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_not_tan) ? _vm._i(_vm.form.is_not_tan, "1") > -1 : (_vm.form.is_not_tan)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.form.is_not_tan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.is_not_tan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.is_not_tan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.form, "is_not_tan", $$c)
        }
      }, function($event) {
        _vm.TANErrorValid()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Not Applicable")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.tan && _vm.errorList.tan) || _vm.TANErrorValidErr || _vm.tanNOError ?
        'red' :
        '',
    }),
    attrs: {
      "id": "client-tan"
    },
    on: {
      "keyup": function($event) {
        _vm.form.is_not_tan == 1 ? '' : _vm.TANErrorValid()
      }
    },
    model: {
      value: (_vm.form.tan),
      callback: function($$v) {
        _vm.$set(_vm.form, "tan", $$v)
      },
      expression: "form.tan"
    }
  }), _vm._v(" "), (!_vm.form.tan && _vm.errorList.tan) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.tan) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.form.tan) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.tanNOError))]) : _vm._e(), _vm._v(" "), (_vm.TANErrorValidErr) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.TANErrorValidErr))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            Contact Name\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.form.kam_name && _vm.errorList.kam_name ? 'red' : '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "kam_name",
      "name": "kam_name",
      "placeholder": "Please Enter Contact Name ",
      "type": "text"
    },
    model: {
      value: (_vm.form.kam_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "kam_name", $$v)
      },
      expression: "form.kam_name"
    }
  }), _vm._v(" "), (!_vm.form.kam_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.kam_name) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            Contact Email\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.kam_email && _vm.errorList.kam_email) || _vm.errorKamEmailFormat ?
        'red' :
        '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "kam_email",
      "name": "kam_email",
      "placeholder": "Please Enter Contact Email ID ",
      "type": "email"
    },
    on: {
      "keyup": _vm.isKamEmailValid
    },
    model: {
      value: (_vm.form.kam_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "kam_email", $$v)
      },
      expression: "form.kam_email"
    }
  }), _vm._v(" "), (!_vm.form.kam_email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.kam_email) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.form.kam_email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorKamEmailFormat))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            Contact Mobile\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        (!_vm.form.kam_mobile && _vm.errorList.kam_mobile) || _vm.errorKamMobileFormat ?
        'red' :
        '',
    }),
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "kam_mobile",
      "name": "kam_mobile",
      "placeholder": "Please Enter Contact Mobile No. ",
      "type": "number"
    },
    on: {
      "keyup": _vm.isKamMobileValid
    },
    model: {
      value: (_vm.form.kam_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "kam_mobile", $$v)
      },
      expression: "form.kam_mobile"
    }
  }), _vm._v(" "), (!_vm.form.kam_mobile) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.kam_mobile) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.form.kam_mobile) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorKamMobileFormat))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "id": "Remark",
      "required": ""
    },
    model: {
      value: (_vm.form.client_remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "client_remark", $$v)
      },
      expression: "form.client_remark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            Will the Client deal with us for EXPORT / IMPORT OR Both?\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.form.quest_export_import && _vm.errorList.quest_export_import ? 'red' : '',
    }),
    attrs: {
      "list": _vm.moduelTypeClientList,
      "id": "quest_export_import",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Client deal Type"
    },
    model: {
      value: (_vm.form.quest_export_import),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_export_import", $$v)
      },
      expression: "form.quest_export_import"
    }
  }), _vm._v(" "), (!_vm.form.quest_export_import) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_export_import) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            CC\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor: !_vm.form.quest_cc && _vm.errorList.quest_cc ? 'red' : '',
    }),
    attrs: {
      "list": _vm.CCList,
      "id": "quest_cc",
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.form.quest_cc),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_cc", $$v)
      },
      expression: "form.quest_cc"
    }
  }), _vm._v(" "), (!_vm.form.quest_cc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_cc) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            FF\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor: !_vm.form.quest_ff && _vm.errorList.quest_ff ? 'red' : '',
    }),
    attrs: {
      "list": _vm.CCList,
      "id": "quest_ff",
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select FF Type"
    },
    model: {
      value: (_vm.form.quest_ff),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_ff", $$v)
      },
      expression: "form.quest_ff"
    }
  }), _vm._v(" "), (!_vm.form.quest_ff) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_ff) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.form.quest_ff == '1') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.form.quest_cont_type_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_cont_type_id", $$v)
      },
      expression: "form.quest_cont_type_id"
    }
  }), _vm._v(" "), (
    (_vm.form.quest_cont_type_id == undefined ||
      _vm.form.quest_cont_type_id == 'undefined' ||
      _vm.form.quest_cont_type_id == null ||
      _vm.form.quest_cont_type_id == 'null' ||
      _vm.form.quest_cont_type_id == '') &&
    _vm.form.is_nomination_shipper == false
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_cont_type_id || "Container Type Fields is Required") + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.quest_ff == '1') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            Define monthly volume in Containers Wise or TEUS\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Enter monthly volume",
      "type": "number"
    },
    model: {
      value: (_vm.form.quest_monthly_volume),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_monthly_volume", $$v)
      },
      expression: "form.quest_monthly_volume"
    }
  }), _vm._v(" "), (
    (_vm.form.quest_monthly_volume == undefined ||
      _vm.form.quest_monthly_volume == 'undefined' ||
      _vm.form.quest_monthly_volume == null ||
      _vm.form.quest_monthly_volume == 'null' ||
      _vm.form.quest_monthly_volume == '') &&
    _vm.form.is_nomination_shipper == false
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_monthly_volume ||
    "Define monthly volume in Containers Wise or TEUS Fields is Required") + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.quest_ff == '1') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_nomination_shipper),
      expression: "form.is_nomination_shipper"
    }],
    staticClass: "mt-5",
    attrs: {
      "id": 'is_nomination_shipper',
      "name": "checkbox-1",
      "type": "checkbox",
      "value": "1",
      "unchecked-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_nomination_shipper) ? _vm._i(_vm.form.is_nomination_shipper, "1") > -1 : (_vm.form.is_nomination_shipper)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.is_nomination_shipper,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form.is_nomination_shipper = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.form.is_nomination_shipper = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.form, "is_nomination_shipper", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("NOMINATION SHIPPER")])]) : (_vm.form.quest_ff == '0') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("\n            FF NA Reason\n            "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.FFNAReasonList,
      "id": "ffOption",
      "option-value": "val",
      "option-text": "text",
      "placeholder": "Select FF NA Reason"
    },
    model: {
      value: (_vm.form.quest_ff_option),
      callback: function($$v) {
        _vm.$set(_vm.form, "quest_ff_option", $$v)
      },
      expression: "form.quest_ff_option"
    }
  }), _vm._v(" "), (!_vm.form.quest_ff_option) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.errorList.quest_ff_option) + "\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.client_name) ? _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Client Document")]), _vm._v(" "), _c('ClientFileUploader', {
    style: ('height: 80px; background: darkgray; width: 100%'),
    attrs: {
      "documentName": 'Client_Multiple_Doc-',
      "otherDocName": 'Client_Multiple_Doc-',
      "folderName": 'CLIENTKYCDOC',
      "accept": '*',
      "assign_no": 'CLIENTKYCDOC',
      "multiple": true,
      "state": Boolean(_vm.form.client_doc),
      "fileAllModuleId": '0'
    },
    model: {
      value: (_vm.form.client_doc),
      callback: function($$v) {
        _vm.$set(_vm.form, "client_doc", $$v)
      },
      expression: "form.client_doc"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.client_doc) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.form.client_doc) ? _c('div', _vm._l((_vm.form.client_doc.split(',')), function(item1, index) {
    return _c('b-button', {
      key: index,
      staticClass: "mb-1",
      staticStyle: {
        "margin-left": "2px",
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          item1 ? _vm.PrintValidity_Doc(item1) : ''
        }
      }
    }, [_vm._v(_vm._s(item1 ? "PDF" + (parseInt(index) + 1) : ""))])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.clientDocError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientDocError))]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mx-auto text-center",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n            Back\n          ")]), _vm._v(" "), (_vm.form.client_kyc_is_converted == 0 && _vm.isLoading == false) ? _c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.saveClientKyc
    }
  }, [_vm._v("\n            Save\n          ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d30f18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientKycTemp/addClientKyc.vue
// module id = 2528
// module chunks = 0